export const formatKes = (value) => {
  const n = Number(value ?? 0);
  return n.toLocaleString("en-KE", { style: "currency", currency: "KES" });
};

export const getTransactionTypeMeta = (transactionTypeId) => {
  if (transactionTypeId === 1) {
    return {
      label: "Money In",
      sx: {
        color: "#2e7d32",
        backgroundColor: "rgba(46, 125, 50, 0.16)",
      },
    };
  }

  if (transactionTypeId === 2) {
    return {
      label: "Money Out",
      sx: {
        color: "#d32f2f",
        backgroundColor: "rgba(211, 47, 47, 0.16)",
      },
    };
  }

  return {
    label: "Unknown",
    sx: {
      color: "#ed6c02",
      backgroundColor: "rgba(237, 108, 2, 0.16)",
    },
  };
};
